import type { CommentableContentObject, Reply } from 'models';
import type { User } from 'features/auth';
import { isProgramAdminProfile } from '../user-roles';
import { isCommunityAdminProfile, isOrganizationAdminProfile, isSuperAdmin } from '../utils';

export const canDeleteComment = ({
  comment,
  contentObject,
  viewer,
}: {
  comment: Reply;
  contentObject: CommentableContentObject;
  viewer: User;
}) => {
  if (isSuperAdmin({ viewer: viewer.railsUserData }) || viewer.railsUserData.id === comment.author.id) {
    return true;
  }

  switch (contentObject.contentableType) {
    case 'Community':
      return (
        isCommunityAdminProfile({ communityId: contentObject.postInCommunities[0].id, viewer: viewer.railsUserData }) ||
        isOrganizationAdminProfile({ organizationId: contentObject.organization.id, viewer: viewer.railsUserData })
      );

    case 'Program':
      return (
        isProgramAdminProfile({ programId: contentObject.program.id, viewer: viewer.railsUserData }) ||
        isOrganizationAdminProfile({ organizationId: contentObject.organization.id, viewer: viewer.railsUserData })
      );
  }
};
